import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingSpinner } from './LoadingSpinner';

const ADMIN_EMAIL = 'mackayla.omalley00@gmail.com';

export function AdminRoute({ children }) {
  const { isAuthenticated, loading, userData, currentUser } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const isAdmin = userData?.role === 'admin' || currentUser?.email === ADMIN_EMAIL;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return children;
}
